import { Record, List } from 'immutable';

const UnitResultRecord = Record({
  unitId: undefined,
  unitSequenceId: undefined,
  level: undefined,
  storyNumber: undefined,
  date: undefined,
  completion: 0,
  accuracy: 0,
  storyRead: 0,
  recorded: 0,
});

class UnitResult extends UnitResultRecord { }

const toNumber = (value) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

UnitResult.create = (data = {}) =>
  new UnitResult({
    unitId: data.unitId,
    unitSequenceId: data.unitSequenceId,
    level: data.level,
    storyNumber: data.storyNumber,
    date: data.unitDateTimeUtc || data.date,
    completion: toNumber(data.completion),
    accuracy: toNumber(data.accuracy),
    storyRead: toNumber(data.storyRead),
    recorded: toNumber(data.recorded),
  });

const StudentHomeworkDetailRecord = Record({
  studentId: undefined,
  studentGeneralInfo: undefined,
  unitResults: new List(),
  status: undefined,
  isInProduction: false,
});

class StudentHomeworkDetail extends StudentHomeworkDetailRecord { }

StudentHomeworkDetail.create = (data = {}) => {
  const unitResults = Array.isArray(data.unitResults)
    ? new List(data.unitResults.map(UnitResult.create))
    : new List();

  return new StudentHomeworkDetail({
    studentId: data.studentId,
    studentGeneralInfo: data.studentGeneralInfo || {},
    unitResults,
    status: data.status,
    isInProduction: !!data.isInProduction,
  });
};

export { UnitResult };
export default StudentHomeworkDetail;



// WEBPACK FOOTER //
// ./data/RAv2HomeworkResultDetail/model.js